// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2cmgb","savePackageButton":"ClientWallet_savePackageButton__1Iqii"};